import axios from "axios";
import { generateToken } from "./token";
import { nanoid } from "nanoid";

const apiUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: apiUrl,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("logged");
    const tokens = await generateToken();

    // Use nanoid only for request identification, not as a token in headers
    const requestToken = nanoid();
    config.headers["xgf-token"] = requestToken;

    if (token) {
      // Only set the Authorization header if the token is available
      config.headers.Authorization = `Bearer ${tokens}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
